import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiYoutube,
  FiArrowRight
} from 'react-icons/fi';
import { GiCrystalBall } from 'react-icons/gi';
import { useTranslation } from '../../hooks/useTranslation';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/online-horoscope-generator', label: t('footer.freeHoroscopeEn') },
    { path: '/jathagam-in-tamil', label: t('footer.freeHoroscopeTa') },
    { path: '/horoscope', label: t('footer.dailyHoroscope') },
    { path: '/zodiac', label: t('footer.zodiacSigns') },
    { path: '/match-making', label: t('footer.matchMakingEn') },
    { path: '/jathagam-porutham-in-tamil-for-marriage', label: t('footer.matchMakingTa') },
  ];

  const zodiacLinks = [
    { path: '/zodiac/aries-mesham-rasi', label: 'Aries (Mesham)' },
    { path: '/zodiac/taurus-rishabam-rasi', label: 'Taurus (Rishabam)' },
    { path: '/zodiac/gemini-mithunam-rasi', label: 'Gemini (Mithunam)' },
    { path: '/zodiac/cancer-kadagam-rasi', label: 'Cancer (Kadagam)' },
    { path: '/zodiac/leo-simham-rasi', label: 'Leo (Simham)' },
    { path: '/zodiac/virgo-kanni-rasi', label: 'Virgo (Kanni)' },
  ];

  const zodiacLinks2 = [
    { path: '/zodiac/libra-thulam-rasi', label: 'Libra (Thulam)' },
    { path: '/zodiac/scorpio-viruchigam-rasi', label: 'Scorpio (Viruchigam)' },
    { path: '/zodiac/sagittarius-dhanusu-rasi', label: 'Sagittarius (Dhanusu)' },
    { path: '/zodiac/capricorn-magaram-rasi', label: 'Capricorn (Magaram)' },
    { path: '/zodiac/aquarius-kumbham-rasi', label: 'Aquarius (Kumbham)' },
    { path: '/zodiac/pisces-meenam-rasi', label: 'Pisces (Meenam)' },
  ];

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            {/* Brand Section */}
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <GiCrystalBall className="footer-logo-icon" />
                <span>AstroEpanchang</span>
              </Link>
              <p className="footer-description">
                {t('footer.description')}
              </p>
              <div className="footer-social">
                <button className="social-link" aria-label="Facebook">
                  <FiFacebook />
                </button>
                <button className="social-link" aria-label="Twitter">
                  <FiTwitter />
                </button>
                <button className="social-link" aria-label="Instagram">
                  <FiInstagram />
                </button>
                <button className="social-link" aria-label="YouTube">
                  <FiYoutube />
                </button>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-links">
              <h4>{t('footer.quickLinks')}</h4>
              <ul>
                {quickLinks.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path}>
                      <FiArrowRight className="link-icon" />
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Zodiac Signs */}
            <div className="footer-links">
              <h4>{t('footer.zodiacSigns')}</h4>
              <div className="zodiac-columns">
                <ul>
                  {zodiacLinks.map((link) => (
                    <li key={link.path}>
                      <Link to={link.path}>{link.label}</Link>
                    </li>
                  ))}
                </ul>
                <ul>
                  {zodiacLinks2.map((link) => (
                    <li key={link.path}>
                      <Link to={link.path}>{link.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Newsletter */}
            <div className="footer-contact">
              <div className="newsletter">
                <h5>{t('footer.subscribe')}</h5>
                <form className="newsletter-form">
                  <input type="email" placeholder={t('footer.emailPlaceholder')} />
                  <button type="submit" className="btn btn-primary btn-sm">
                    <FiArrowRight />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} {t('footer.copyright')}</p>
            <div className="footer-bottom-links">
              <Link to="/privacy">{t('footer.privacy')}</Link>
              <Link to="/terms">{t('footer.terms')}</Link>
              <Link to="/refund">{t('footer.refund')}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
